import React from "react";
import { Button, Form, Modal, Select, Spin, theme, Typography } from "antd";
import * as _ from "lodash";
import useDropdownItem from "../../common/useDropdownItem";
import { URL_SALE, URL_SKIM } from "../../constants/urls";
import ColorButton from "../../common/ColorButton";
import { POST } from "../../frameworks/HttpClient";
import { PRODUCT_TYPE } from "../../constants/string";
import ErrorMessages from "../../common/ErrorMessages";

export default function SkimProduceChangePOModal({
  open=false,
  target=null,
  onCancel=() => null,
  onSuccess=() => null,
}) {
  const targetId = _.get(target, 'id', null);
  const targetProduct = _.get(target, 'product', null)
  const [form] = Form.useForm();
  const { token: { colorWarning } } = theme.useToken();
  const orderRef = Form.useWatch('order_ref', form);  
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [debouncedOrderRef, setDebouncedOrderRef] = React.useState('');
  const debounceOrderRef = React.useCallback(_.debounce((_searchVal) => { setDebouncedOrderRef(_searchVal) }, 800), []);
  const { Text } = Typography;

  const poDropdown = useDropdownItem({
    manual : true,
    url: URL_SALE.SKIM_PRODUCE_ORDER,
    pagination: true,
    params: { page_size: 999, type: PRODUCT_TYPE.SKIM, lot_no : debouncedOrderRef , is_produced : false},
    label_renderer : (option) => `Lot No.: ${option.lot_no} ชนิดสินค้า: ${option.product_name}`,
  })

  React.useEffect(() => {
    if (open) {
      form.setFieldsValue(target);
      setErrorMessage(null);
      poDropdown.fetchOptions();
    } else {
      form.resetFields();
    }
  }, [open])

  React.useEffect(() => {
    if (open) {
      poDropdown.fetchOptions();
    }
  }, [debouncedOrderRef])

  const onSubmit = async () => {
    setLoading(true);
    setErrorMessage(null);
    try {
      const values = await form.validateFields();
      await POST(`${URL_SKIM.SKIM_PRODUCE_TRANSACTION}${targetId}/change-produce-order/`, values);
      onSuccess();
    } catch (error) {
      setErrorMessage(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      title='เปลี่ยนใบแจ้งผลิต'
      open={open}
      onCancel={onCancel}
      footer={[
        <Button onClick={onCancel}>ยกเลิก</Button>,
        <ColorButton override={colorWarning} type='primary' loading={loading} onClick={onSubmit}>
          แก้ไข
        </ColorButton>
      ]}
    >
      <ErrorMessages message={errorMessage}/>
      <Form form={form}>
        <Form.Item name='order_ref' label='ใบแจ้งผลิต'>
          <Select 
            showSearch
            allowClear
            disabled={target?.deliveried}
            filterOption={false}
            options={target && orderRef ? _.filter([...poDropdown.options, 
              { value : target.order_ref, label : `Lot No: ${target.produce_lot_no} ชนิดสินค้า: ${target.product_name}`}]
              , o => o.value !== null) : poDropdown.options}
            onSearch={debounceOrderRef}
            notFoundContent={poDropdown.loading ? <Spin size="small" /> : "-"}
            />
        </Form.Item>
        <center>{target?.deliveried && <Text type="danger">** หากโหลดสินค้าแล้วจะไม่สามารถเปลี่ยนใบแจ้งผลิตได้</Text>}</center>
      </Form>
    </Modal>
  )
}